module.exports = __webpack_public_path__ + "img/version_beta-01.acdfb70b.svg";